import {
  AgStepbarItem,
  AgDropMenu,
  AgDropMenuContent
} from '@rededor/ag-shared-components-react'
import { useStepStatus } from '@/hooks/useStepStatus'
import { useIsActiveBreakPoint } from '@/hooks/useIsActiveBreakPoint'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useStepAction } from './useStepAction'

export const DoctorSpecialtyStep = () => {
  const isMobile = useIsActiveBreakPoint('medium', 'max')
  const doctor = useScheduleStore((state) => state.doctor)
  const product = useScheduleStore((state) => state.product)

  const isDigitalConsultation = product?.isDigitalConsultation
  const nameModality = isDigitalConsultation ? 'Teleconsulta' : 'Presencial'

  const { handleClickAction, handleSelectStep } = useStepAction('/')

  const step = isMobile ? 'Especialidade' : 'Especialidade/Médico'
  const doctorInfo = doctor?.name ? `${doctor.name}` : ''
  const productName = product?.name
    ? `${product?.name || ''} - ${nameModality}`
    : ''
  const targetStep = 'specialty'
  const status = useStepStatus({
    isCompleted: Boolean(doctor?.id || product?.id),
    targetPath: '/',
    targetStep
  })

  return (
    <AgStepbarItem
      step={step}
      info={doctorInfo || productName}
      icon="medical"
      status={status}
      targetStep={targetStep}
      onSelectStep={handleSelectStep}
    >
      <AgDropMenu>
        <AgDropMenuContent
          step={step}
          info={doctorInfo || productName}
          labelAction="Alterar especialidade/médico"
          onClickAction={handleClickAction}
        />
      </AgDropMenu>
    </AgStepbarItem>
  )
}
